import {
	type PricelistProductSalesChannelUpsertInput,
	usePricelistProductSalesChannelUpsertMutation,
} from "@/generated/graphql";

export const usePricelistProductSalesChannelUpsert = () => {
	const [, upsert] = usePricelistProductSalesChannelUpsertMutation();

	const upsertPricelistProductSalesChannel = (
		input: PricelistProductSalesChannelUpsertInput,
	) => {
		return upsert({ input });
	};

	return {
		upsertPricelistProductSalesChannel,
	};
};
